import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

function InfoTip({ text }) {
    const [pos, setPos] = useState(null);

    return (
        <span
            style={{ marginLeft: '0.3rem', cursor: 'help', color: 'inherit', opacity: 0.6, verticalAlign: 'middle', display: 'inline-flex' }}
            onMouseEnter={(e) => setPos({ x: e.clientX, y: e.clientY })}
            onMouseMove={(e) => setPos({ x: e.clientX, y: e.clientY })}
            onMouseLeave={() => setPos(null)}
        >
            <svg viewBox="0 0 20 20" fill="currentColor" width="13" height="13">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            {pos && ReactDOM.createPortal(
                <div style={{
                    position: 'fixed',
                    top: pos.y + 16,
                    left: pos.x + 8,
                    zIndex: 99999,
                    background: '#1f342a',
                    color: '#eceadf',
                    padding: '9px 12px',
                    borderRadius: '8px',
                    fontSize: '0.75rem',
                    lineHeight: '1.5',
                    maxWidth: '280px',
                    pointerEvents: 'none',
                    border: '1px solid rgba(168, 196, 147, 0.18)',
                    boxShadow: '0 8px 24px rgba(16, 32, 15, 0.22)',
                    whiteSpace: 'normal',
                }}>
                    {text}
                </div>,
                document.body
            )}
        </span>
    );
}

InfoTip.propTypes = {
    text: PropTypes.string.isRequired,
};

export default InfoTip;
